import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { friendlyError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import { Card, EmptyState, Skeleton } from "@/ui";
import { Store } from "lucide-react";

export default function ShopPicker() {
  const { chooseShop } = useAuth();
  const navigate = useNavigate();
  const [shops, setShops] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/shops").then((res) => setShops(res.data)).catch((e) => setError(friendlyError(e))).finally(() => setLoading(false));
  }, []);

  const pick = (s) => { chooseShop(s.id, s.name); navigate("/today", { replace: true }); };

  return (
    <Layout shopName="">
      <h1 className="t-h1" style={{ marginBottom: 8 }}>pick a shop</h1>
      <p className="muted" style={{ marginBottom: 24 }}>choose which shop you want to open.</p>
      {error ? <div className="err-text" style={{ marginBottom: 12 }}>{error}</div> : null}
      {loading ? (
        <div className="stack"><Skeleton variant="card" /><Skeleton variant="card" /></div>
      ) : shops.length === 0 ? (
        <EmptyState icon={<Store size={20} strokeWidth={1.75} />} title="you have no shops yet — ask the platform owner or your partner to add one" />
      ) : (
        <div className="grid grid-2">
          {shops.map((s) => (
            <Card key={s.id} interactive data-testid={`pick-shop-${s.id}`} onClick={() => pick(s)}>
              <div className="t-h3">{s.name}</div>
              <div className="muted t-small">{s.address}</div>
            </Card>
          ))}
        </div>
      )}
    </Layout>
  );
}
